import AjaxUtil from '../../axios/axios';

/**
 * 
 * @param {*} data 
 * @returns 
 */
export const addGroups = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`group`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Update groups
 * @param {object} data 
 * @returns 
 */
export const updateGroups = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`group/master?master=${data.view_master}&id=${data.id}`, {}, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * edit group
 * @param {string} id 
 */
export const editGroup = async(id, data) => {
    try {
        return await AjaxUtil.sendRequest(`group`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * delete group
 * @param {string} id 
 * @returns 
 */
export const deleteGroup = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`group/${id}`, {}, false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}


/**
 * 
 * @param {*} id 
 * @returns 
 */
export const getGroups = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`groups?topic_id=${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const searchGroup = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`groups?key=`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getRoles = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`roles`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * fetch form templates
 */
export const getFormTemplates = async(type) => {
    try {
        return await AjaxUtil.sendRequest(`formtemplates/${type}`, {}, false, { method: 'get', showError: true, isProfile: false} );
    } catch (error) {
        throw error;
    }
}

/**
 * fetch form usage types
 */
export const getFormUsageTypes = async() => {
    try {
        return await AjaxUtil.sendRequest(`futypes?account_type=NGO`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * fetch form templates
 */
export const postFormTemplates = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form/from/template`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * create copy of form
 */
export const postFormCopy = async(formid,data) => {
    try {
        return await AjaxUtil.sendRequest(`form/${formid}/clone`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 * @param {g} projectId 
 * @param {*} id 
 * @returns 
 */

export const getUsers = async(projectId, id) => {
    try {
        return await AjaxUtil.sendRequest(`team/${projectId}/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const createGroup = async() => {
    try {
        let data = {
            "name": "Group 1",
            "description": "Group 1",
            "topicid": "C4215",
            "group_type": "test_group"
        }
        return await AjaxUtil.sendRequest(`group`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}




export const getForms = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`forms/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getFormData = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`form/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const createForm = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const updateForm = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const deletForm = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`form/${id}`, {}, false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getVariables = async(keyword, page) => {
    try {
        return await AjaxUtil.sendRequest(`variables/search?key=${keyword}&page=${page}&per_page=20`, {}, false, { method: 'get', showError: true, isProfile: true, isHeaders: true} );
    } catch (error) {
        throw error;
    }
}

export const getVariableTypes = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`variable/types`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getVariableValidations = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`variable/validations`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const createVariable = async(data, formId) => {
    try {
        return await AjaxUtil.sendRequest(`form/${formId}/variable`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getVariable = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`variable/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const updateVariable = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`variable`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const deleteVariable = async(formId, variableId) => {
    try {
        return await AjaxUtil.sendRequest(`variable/${formId}/${variableId}`, {}, false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getFormVariables = async(formId) => {
    try {
        return await AjaxUtil.sendRequest(`form/${formId}/variables`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const arrangeCategories = async(formId, data) => {
    try {
        return await AjaxUtil.sendRequest(`form/${formId}/variables`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const onAction = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form/action`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}
/**
 * 
 * @param {*} formId 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
export const getFormRecords = async(formId, page, size, checkAll) => {

    try {
        if(checkAll == false){
            return await AjaxUtil.sendRequest(`form/${formId}/responses?page=${page}&per_page=${size}&l=l`, {}, false, { method: 'get', showError: true, isProfile: true} );
        }else{
            return await AjaxUtil.sendRequest(`form/${formId}/responses?page=${page}&per_page=${size}`, {}, false, { method: 'get', showError: true, isProfile: true} );
        }
    } catch (error) {
        throw error;
    }
}

/**
 * get filter form data
 * @param {*} formId 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
export const getFilteredFormRecords = async(formId,data,page, size,checkAll) => {
    try {
        if(checkAll == false){
            return await AjaxUtil.sendRequest(`form/sr/${formId}?page=${page}&per_page=${size}&l=l`, data, false, { method: 'post', showError: true, isProfile: true} );
        }else{
            return await AjaxUtil.sendRequest(`form/sr/${formId}?page=${page}&per_page=${size}`, data, false, { method: 'post', showError: true, isProfile: true} );
        }
    } catch (error) {
        throw error;
    }
}

/**
 * 
 * @param {*} recordId 
 * @returns 
 */

export const deleteRecord = async(recordId) => {
    try {
        return await AjaxUtil.sendRequest(`form/response/${recordId}`, {}, false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Upload
 * @param {*} formData 
 * @returns 
 */
export const uploadRecord = async(formData) => {
    try {
        return await AjaxUtil.sendRequest(`form/responses/upload`, formData, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const downloadFieldTemplate = async(formId) => {
    //const headers =  {'Content-Type': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}, responseType: "arraybuffer"}
    try {
        return await AjaxUtil.sendRequestFile(`form/${formId}/variables/download`, {}, false, { method: 'get', showError: true, isProfile: true,responseType: "arraybuffer"} );
    } catch (error) {
        throw error;
    }
}

export const downloadFormData = async(formId) => {
    // const headers =  headers: {'Content-Type': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}, responseType: "arraybuffer"}
    try {
        return await AjaxUtil.sendRequest(`form/${formId}/data/download`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const downloadAnalyticalData = async(topicId) => {
    // const headers =  headers: {'Content-Type': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}, responseType: "arraybuffer"}
    try {
        return await AjaxUtil.sendRequest(`ad/download/${topicId}`, {}, false, { method: 'get', showError: true, isProfile: true,responseType: "arraybuffer"} );
    } catch (error) {
        throw error;
    }
}

export const getNonSurveyForm = async(formId,checkAll) => {
    let versionid  = Number(localStorage.getItem("versionid"));

    try {
        if(checkAll == false){
            return await AjaxUtil.sendRequest(`form/${formId}/datacollect?version_id=${versionid}&l=l`, {}, false, { method: 'get', showError: true, isProfile: true} );  
        }else{
            return await AjaxUtil.sendRequest(`form/${formId}/datacollect?version_id=${versionid}`, {}, false, { method: 'get', showError: true, isProfile: true} );
        }
    } catch (error) {
        throw error;
    }
}

export const submitIdentifierForm = async(reqObj) => {
    try {
        return await AjaxUtil.sendRequest(`form/submit`, reqObj, false, {method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * update record
 * @param {*} reqObj 
 * @returns 
 */
export const updateIdentifierForm = async(reqObj) => {
    try {
        return await AjaxUtil.sendRequest(`form/response`, reqObj, false, {method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * update record review or approval
 * @param {*} reqObj 
 * @returns 
 */
export const updateReviewApproveForm = async(reqObj,type) => {
    try {
        return await AjaxUtil.sendRequest(`form/sresponse?s_t=${type}`, reqObj, false, {method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * validate the data entry form data
 * @param {*} formId 
 * @param {*} reqObj 
 * @returns 
 */
export const validateIdentifierForm = async(formId, reqObj) => {
    try {
        if(formId == ""){
            return await AjaxUtil.sendRequest(`variable/validate`, reqObj, false, { method: 'post', showError: true, isProfile: true} );

        }else{
            return await AjaxUtil.sendRequest(`variable/validate?source_form_id=${formId}`, reqObj, false, { method: 'post', showError: true, isProfile: true} );

        }
    } catch (error) {
        throw error;
    }
}

/**
 * 
 * @param {*} formId 
 * @param {*} fieldId 
 * @param {*} answer 
 * @returns 
 */
export const fetchNextVariable = async(formId, fieldId, answer, checkAll) => {
    let versionid = localStorage.getItem("versionid");
    let answers = encodeURIComponent(answer)
    try {
        if(checkAll == false){
            return await AjaxUtil.sendRequest(`variable/next?form_id=${formId}&field_id=${fieldId}&answer=${answers}&version_id=${versionid}&l=l`, {}, false, { method: 'get', showError: true, isProfile: true} );
        }else{
            return await AjaxUtil.sendRequest(`variable/next?form_id=${formId}&field_id=${fieldId}&answer=${answers}&version_id=${versionid}`, {}, false, { method: 'get', showError: true, isProfile: true} );
        }
    } catch (error) {
        throw error;
    }
}

/**
 * update strict mode
 */
export const updateStrictMode = async(id,data) => {
    try {
        return await AjaxUtil.sendRequest(`form/${id}/lock/toggle`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get tree data
 */
export const getTreeData = async(formid,versionid) => {
    try {
        return await AjaxUtil.sendRequest(`/variable/flows?form_id=${formid}&version_id=${versionid}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get target forms list  
 */
export const getTargetFormList = async(formId) => {
    try {
        return await AjaxUtil.sendRequest(`dforms/${formId}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * post array of ids 
 * 
 */
export const postgenerateLink = async(formId,targetId,idArray) => {
    try {
        return await AjaxUtil.sendRequest(`sle/${formId}/${targetId}`, idArray, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * update rearranged data
 */
export const updateRearrangedData = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form/order`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * create criteria
 */
export const postCreateCriteria = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form/criteria`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * update criteria
 */
export const updateCreateCriteria = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form/criteria`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get list of criteria
 */
export const getCriteria = async(groupid) => {
    try {
        return await AjaxUtil.sendRequest(`all/criteria/${groupid}`, {}, false, { method: 'get', showError: true, isProfile: true});
    } catch (error) {
        throw error;
    }
}

/**
 * delete criteria
 */
export const deleteCriteriaItem = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`form/criteria/${id}`, {}, false, { method: 'delete', showError: true, isProfile: true});
    } catch (error) {
        throw error;
    }
}

/**
 * Apply criteria
 */
export const postApplyCriteria = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`form/criteria/${id}/process`, {}, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Apply criteria
 */
export const postAskQuestion = async(id,data) => {
    try {
        return await AjaxUtil.sendRequest(`qfai/${id}`, data, false, { method: 'post', showError: true, isAnalysisAI: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Get Visualization Data
 */
export const getVisualisationData = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`form/${id}/data/explore`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * serach index post call
 */
export const postSearchIndex = async(id,formId,data,checkAll) => {
    try {
        if(checkAll == false){
            return await AjaxUtil.sendRequest(`form/sir/${id}/${formId}?page=1&per_page=10&l=l`, {"search_data":data}, false, { method: 'post', showError: true, isProfile: true} );
        }else{
            return await AjaxUtil.sendRequest(`form/sir/${id}/${formId}?page=1&per_page=10`, {"search_data":data}, false, { method: 'post', showError: true, isProfile: true} );
        }
    } catch (error) {
        throw error;
    }
}

/**
 * 
 */
export const updateBulkForm = async(reqObj) => {
    try {
        return await AjaxUtil.sendRequest(`form/responses/bulk`, reqObj, false, {method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * submit rules
 */
export const postRules = async(id,data,methodtype) => {
    try {
        return await AjaxUtil.sendRequest(`formrules/${id}`, data, false, { method: methodtype, showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get list of rules
 */
export const getRules = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`formrules/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const uploadFileData = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form/responses/upload`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}


export const uploadFileDataStatus = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`/form/responses/uploaded/status?form_id=${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const downloadFileDataStatus = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`/form/responses/downloaded/status?form_id=${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get summary data
 */
export const getSummaryData = async(id,fid,data) => {
    try {
        return await AjaxUtil.sendRequest(`/form/ms/${id}/${fid}`, {"search_data":data}, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get record summary data
 */
export const getRecordSummary = async(masterUID,fid) => {
    try {
        return await AjaxUtil.sendRequest(`/getmastersummary/${fid}/${masterUID}`, false, { method: 'get', showError: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get master ai summary data
 */
export const getMasterAiSummary = async(data, topic_id, form_id, ai_module_id) => {
    try {
        return await AjaxUtil.sendRequest(`/master_ai_summary?topic_id=${topic_id}&form_id=${form_id}&ai_module_id=${ai_module_id}`, data , false, { method: 'post', showError: true, isProfile : false, isRagUrl: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get master summary report data
 */
export const getMasterSummaryReport = async(data, topic_id, form_id, ai_module_id) => {
    try {
        return await AjaxUtil.sendRequest(`/generic_ai_summary?topic_id=${topic_id}&form_id=${form_id}&ai_module_id=${ai_module_id}`, data , false, { method: 'post', showError: true, isProfile : false, isRagUrl: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 * @param {*} id 
 * @returns 
 */
export const getDownloadedFile = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`/form/downloadstatus?job_id=${id}`, {}, false, { method: 'get', showError: true, isProfile: true, isBlob: true} );
    } catch (error) {
        throw error;
    }
}


/**
 * download error report
 */
export const getErrorFile = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`/form/uploadstatus?job_id=${id}`, {}, false, { method: 'get', showError: true, isProfile: true, isBlob: true} );
    } catch (error) {
        throw error;
    }
}

export const getVarConfig = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`varconfig/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const saveVarConfig = async(id,data) => {
    try {
        return await AjaxUtil.sendRequest(`varconfig/${id}`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getRecord = async(id,version_id) => {
    try {
        return await AjaxUtil.sendRequest(`form/response?response_id=${id}&version_id=${version_id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const updateRecords = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`form/responses/update`, data , false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}


/**
 * Get unique Data
 */
export const getUniqueData = async(id,fid) => {
    try {
        return await AjaxUtil.sendRequest(`ufv/${id}/${fid}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}


/**
 * get data status
 */
export const getDataStatus = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`form/ams/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * add validation Rule 
 */
export const addValidationRule = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`addvalidationrule`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get validation Rules
 */
export const getValidationRules = async(topicId,formGroupId) => {
    try {
        return await AjaxUtil.sendRequest(`getvalidationrule/${topicId}/${formGroupId}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * update validation Rule 
 */
export const updateValidationRule = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`updatevalidationrule`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * delete Validation Rule 
 */
export const deleteValidationRule = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`deletevalidationrule/${id}`, {}, false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * add Alert Rule 
 */
export const addAlertRule = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`addalert`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get Alert Rules
 */
export const getAlertRules = async(topicId,formGroupId) => {
    try {
        return await AjaxUtil.sendRequest(`getalert/${topicId}/${formGroupId}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * update Alert Rule 
 */
export const updateAlertRule = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`updatealert`, data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * delete Alert Rule 
 */
export const deleteAlertRule = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`deletealert/${id}`, {}, false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * fetch ocr preview file data
 * @params id : record id
 */
export const getFilePreviewData = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`getocr/${id}`, {}, false, { method: 'get', showError: true, isProfile: false} );
    } catch (error) {
        throw error;
    }
}

/**
 * upload ocr dump files
 * 
 */
export const uploadDumpFiles = async(topic_id, target_form_id, ai_module_id, data) => {
    try {
        return await AjaxUtil.sendRequest(`uploadzip/?topic_id=${topic_id}&target_form_id=${target_form_id}&ai_module_id=${ai_module_id}`, data, false, { method: 'post', showError: true, isProfile: false, isRagUrl : true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get ocr dump files status
 * 
 */
export const getDumpFilesStatus = async(topic_id, target_form_id) => {
    try {
        return await AjaxUtil.sendRequest(`ocr-status/?topic_id=${topic_id}&target_form_id=${target_form_id}`, {} , false, { method: 'get', showError: true, isProfile: false, isRagUrl : true} );
    } catch (error) {
        throw error;
    }
}

/**
 * delete multiple records
 * 
 */
export const deleteRecords = async(recordIds) => {
    try {
        return await AjaxUtil.sendRequest(`form/responses/delete`, recordIds , false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * upload conversation audio files
 * 
 */
export const uploadConversationAudioFiles = async(topic_id, target_form_id, numSpeakers, promptMessage, data) => {
    try {
        return await AjaxUtil.sendRequest(`uploadzip/?topic_id=${topic_id}&target_form_id=${target_form_id}&num_speakers=${numSpeakers}&prompt=${promptMessage}`, data, false, { method: 'post', showError: true, isProfile: false, isRagUrl : true} );
    } catch (error) {
        throw error;
    }
}

export const getRecordsUidFields = async(topicId, formId, pageNo = 1, perPage = 100) => {
    try {
        return await AjaxUtil.sendRequest(`fieldvalues/${topicId}/${formId}?page=${pageNo}&per_page=${perPage}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const uploadSpeechToTextAudioFiles = async (data, params) => {
    try {
        const query = new URLSearchParams(params).toString();

        return await AjaxUtil.sendRequest(
            `upload_speech_bulk/`,
            data,
            false,
            { method: 'post', showError: true, isProfile: false, isRagUrl: true }
        );
    } catch (error) {
        throw error;
    }
};

/**
 * upload project level ocr files
 * 
 */
export const uploadProjectOcrFiles = async(topic_id, aiModuleId, data) => {
    try {
        return await AjaxUtil.sendRequest(`uploadzip/?topic_id=${topic_id}&ai_module_id=${aiModuleId}`, data, false, { method: 'post', showError: true, isProfile: false, isRagUrl : true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Save printable template
 * 
 */
export const savePrintableTemplate = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`create/template`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Get printable template
 * 
 */
export const getPrintableTemplates = async(topic_id) => {
    try {
        return await AjaxUtil.sendRequest(`get/template/${topic_id}`, {} , false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * update printable template
 * 
 */
export const updatePrintableTemplate = async(template_id, data) => {
    try {
        return await AjaxUtil.sendRequest(`update/template/${template_id}`, data , false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * delete printable template
 * 
 */
export const deletePrintableTemplate = async(template_id) => {
    try {
        return await AjaxUtil.sendRequest(`delete/template/${template_id}`, {} , false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Get printable template
 * 
 */
export const getTemplateFilters = async(templateId) => {
    try {
        return await AjaxUtil.sendRequest(`/get/templatefilters/${templateId}`, {} , false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * Get printable template
 * 
 */
export const getTemplateRecords = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`/get/templaterecords`, data , false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 * get short url
 * @param {*} url 
 * @returns 
 */
export const getShortUrl = async (url) => {
    try {
        return await AjaxUtil.sendRequest(`get/shorturl?url=${encodeURIComponent(url)}`, {}, false, { method: 'get', showError: true, isProfile: true });
    } catch (error) {
        throw error;
    }
}